"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
const util_1 = require("./util");
class HttpChainClient {
    someChain;
    options;
    httpOptions;
    constructor(someChain, options = index_1.defaultChainOptions, httpOptions = util_1.defaultHttpOptions) {
        this.someChain = someChain;
        this.options = options;
        this.httpOptions = httpOptions;
    }
    async get(roundNumber) {
        const url = withCachingParams(`${this.someChain.baseUrl}/public/${roundNumber}`, this.options);
        return await (0, util_1.jsonOrError)(url, this.httpOptions);
    }
    async latest() {
        const url = withCachingParams(`${this.someChain.baseUrl}/public/latest`, this.options);
        return await (0, util_1.jsonOrError)(url, this.httpOptions);
    }
    chain() {
        return this.someChain;
    }
}
function withCachingParams(url, config) {
    if (config.noCache) {
        return `${url}?${Date.now()}`;
    }
    return url;
}
exports.default = HttpChainClient;
//# sourceMappingURL=http-chain-client.js.map